import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';

import 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss';

const AmountLineItem = ({ amount, label, showZero }) => {
    return amount !== 0 || showZero ? (
        <li className="SidebarSummary__listingAmount--item sr-text-regular amountLineItem">
            <span className="label">{label}</span>
            <span className="value">{LocaleService.l(amount, CurrencyFormats.CURRENCY_0)}</span>
        </li>
    ) : null;
};

AmountLineItem.defaultProps = {
    showZero: false,
};

AmountLineItem.propTypes = {
    amount: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    showZero: PropTypes.bool,
};

AmountLineItem.displayName = 'AmountLineItem';

export default AmountLineItem;



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx